// AMBIENTE LOCAL
// export const API_URL = 'http://192.168.1.96:4000';

// AMBIENTE DESENVOLVIMENTO
// export const API_URL = 'https://zaf-dev.herokuapp.com/v1';

// AMBIENTE PRODUÇÃO
export const API_URL = 'https://zad-transitar.herokuapp.com/v1';

// LOGIN
export function TOKEN_POST(body) {
  return {
    url: API_URL + '/user/login',
    options: {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    },
  };
}

// LISTAR PDVS
export function LISTAR_PDVS_GET({ offset, limit }) {
  return {
    url: `${API_URL}/adm/pdvs?offset=${offset}&limit=${limit}`,
    options: {
      method: 'GET',
      cache: 'no-store',
      headers: {
        'Content-Type': 'application/json',
        Authorization: window.localStorage.getItem('token'),
      },
    },
  };
}

// LISTAR USUÁRIOS
export function LISTAR_USUARIOS_GET({ offset, limit }) {
  return {
    url: `${API_URL}/adm/users?offset=${offset}&limit=${limit}`,
    options: {
      method: 'GET',
      cache: 'no-store',
      headers: {
        'Content-Type': 'application/json',
        Authorization: window.localStorage.getItem('token'),
      },
    },
  };
}

// ADICIONAR CADS
export function ADICIONAR_CADS_POST(body) {
  return {
    url: API_URL + '/addCADs',
    options: {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: window.localStorage.getItem('token'),
      },
      body: JSON.stringify(body),
    },
  };
}

// GERAR CSV PARA NOTAS FISCAIS
export function GERAR_CSV_GET({ startDate, endDate, userType, isCNPJ }) {
  return {
    url: `${API_URL}/taxReportCSV?startDate=${startDate}&endDate=${endDate}&userType=${userType}&isCNPJ=${isCNPJ}`,
    options: {
      method: 'GET',
      headers: {
        // 'Content-Type': 'text/csv',
        Authorization: window.localStorage.getItem('token'),
      },
      // responseType: 'blob',
    },
  };
}

// HISTÓRICO DE ESTACIONAMENTO
export function HISTORICO_DE_ESTACIONAMENTO_GET({
  startDate,
  endDate,
  cpf_cnpj,
  userType,
  licensePlate,
}) {
  return {
    url: `${API_URL}/adm/historyParkings?startDate=${startDate}&endDate=${endDate}&cpf_cnpj=${cpf_cnpj}&userType=${userType}&licensePlate=${licensePlate}&limit=3000`,
    options: {
      method: 'GET',
      headers: {
        // 'Content-Type': 'text/csv',
        Authorization: window.localStorage.getItem('token'),
      },
      // responseType: 'blob',
    },
  };
}
